import React from 'react';

function Privacy() {
  return (
    <div className="policy-container">
      <h1>Privacy Policy for ClaimYourCrash.com</h1>
      <p><strong>Last updated: October 20, 2025</strong></p>
      <p>This privacy notice for ClaimYourCrash.com ("Company," "we," "us," or "our") describes how and why we might collect, store, use, and/or share ("process") your information when you use our services ("Services"), such as when you:</p>
      <ul>
        <li>Visit our website at ClaimYourCrash.com, or any website of ours that links to this privacy notice</li>
        <li>Submit a form to generate leads for car accident consultations</li>
      </ul>
      <p>We comply with applicable data privacy laws, including TCPA for phone communications and CAN-SPAM for emails. By using our Services, you agree to the practices described in this policy.</p>

      <h2>Information We Collect</h2>
      <p>We collect personal information you provide when using our Services, such as:</p>
      <ul>
        <li>Full name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Details about your car accident (e.g., date, location, description)</li>
        <li>IP address and device information (for analytics)</li>
      </ul>
      <p>We collect this data directly from you via forms on ClaimYourCrash.com. We do not collect sensitive information beyond what's necessary for lead generation.</p>

      <h2>How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Provide consultations and connect you with legal professionals for car accident claims</li>
        <li>Send emails or texts about your inquiry (complying with CAN-SPAM for emails and TCPA for calls/texts, including prior express consent for automated communications)</li>
        <li>Improve our Services through analysis</li>
      </ul>
      <p>We retain data only as long as necessary for these purposes or as required by law.</p>

      <h2>Sharing Your Information</h2>
      <p>We do not share, sell, or disclose your personal information without your permission. We may share anonymized data with service providers for processing (e.g., email delivery), but only under strict confidentiality. No sharing occurs for marketing without opt-in consent. In the event of a business transfer, we will notify you.</p>

      <h2>Security</h2>
      <p>We implement reasonable security measures, such as encryption and firewalls, to protect your information from unauthorized access, loss, or misuse. However, no system is completely secure, and we cannot guarantee absolute protection.</p>

      <h2>Your Rights</h2>
      <p>You have rights over your data, including:</p>
      <ul>
        <li>Access, correction, or deletion of your information</li>
        <li>Opt-out of communications: Reply "STOP" to texts (TCPA compliance) or unsubscribe via email links (CAN-SPAM compliance)</li>
        <li>Withdraw consent for processing at any time</li>
      </ul>
      <p>To exercise these rights, contact us below. We honor universal opt-out mechanisms where applicable.</p>

      <h2>Contact Us</h2>
      <p>If you have questions about this policy or your data, contact us at:</p>
      <ul>
        <li>Email: privacy@claimyourcrash.com</li>
        <li>Phone: (844) 522-1358</li>
        <li>Address: [Insert Company Address]</li>
      </ul>
      <p>We may update this policy; check back for changes.</p>
    </div>
  );
}

export default Privacy;
